import { ReactNode } from 'react';
import styled from 'styled-components';
import { FLOATING_MANAGER_ID } from './utils';
import { DEFAULT_FLOATING_Z_INDEX } from '../../styles/zIndexes';
import { StyledToastContainer } from '../../utils/toastMessage/toastMessageUI';

/**
 * This component is a host for Popover(@mui/material), Fullscreen
 * container(semantic-ui-react), and Contextual menus(@fluentui/react).
 *
 * This host should replace all library built-in z-indexes
 */

interface IProps {
  children?: ReactNode;
}

const HostComponent = styled.div`
  position: fixed !important;
  z-index: ${DEFAULT_FLOATING_Z_INDEX} !important;

  // @mui/material popovers
  .MuiPopover-root {
    z-index: ${DEFAULT_FLOATING_Z_INDEX} !important;
  }

  // @Kostya: @fluentui/react has a special Context Provider component - Host. It wraps
  // all Callout components (ContextualMenus). By default Host component
  // has enormous z-index. In order to get a full control on z-indexes -
  // we have to reduce z-index of the host.
  .ms-Layer--fixed {
    // increase by 1 in order to render it on top of Popover
    z-index: ${DEFAULT_FLOATING_Z_INDEX + 1} !important;
  }
`;

const FloatingManager = ({ children }: IProps) => {
  return (
    <>
      <HostComponent id={FLOATING_MANAGER_ID}>
        {children}
        <div
          // Create a custom div with @fluentui/react library-specific id
          // to render all fluent components here in the host
          id="fluent-default-layer-host"
        />
      </HostComponent>
      <StyledToastContainer />
    </>
  );
};

export default FloatingManager;
